import config from 'config';

export function assetPath(path) {
  return `${config.assetsHost}/static/${path}`;
}

export function imagePath(path) {
  return assetPath(`images/${path}`);
}
